import { FC, memo } from "react";
// Redux
import { useAppSelector } from "hooks/useStore";
// Selectors
import { selectExpertCurrectScore, selectMaxScore, selectTotalScore } from "store/player/playerSelectors";
import { selectQuiz } from "store/quiz/quizSelectors";

const expertColor = '#ffb347';

const BeatTheExpertQuestionProgress:FC = () => {
  const quiz = useAppSelector(selectQuiz);
  const totalScore = useAppSelector(selectTotalScore);
  const maxScore = useAppSelector(selectMaxScore);
  const expertScore = useAppSelector(selectExpertCurrectScore)

  const playerWidth = (totalScore / maxScore) * 100;
  const expertWidth = (expertScore / maxScore) * 100;

  return (
    <div className="p-4">
      <div className="shadow-primary p-3">
        <div className="mb-2 flex text-white">
          <p
            className={`w-16 pl-1 rounded-l ${totalScore === 0 ? 'rounded-r' : ''} font-bold`}
            style={{ backgroundColor: quiz.theme.progressBarColor }}
          >You</p>
          <div className="flex-grow">
            <div
              className="h-full rounded-r"
              style={{ backgroundColor: quiz.theme.progressBarColor, width: `${playerWidth}%`, transition: 'width 0.5s ease-in-out' }}
            />
          </div>
          <p className="w-28 text-right font-bold">
            You: <span style={{ color: quiz.theme.progressBarColor }}>{totalScore.toLocaleString('en-US')}</span>
          </p>
        </div>
        <div className="flex text-white">
          <p
            className={`w-16 pl-1 rounded-l font-bold ${expertScore === 0 ? 'rounded-r' : ''}`}
            style={{ backgroundColor: expertColor }}
          >Expert</p>
          <div className="flex-grow">
            <div
              className="h-full rounded-r"
              style={{ backgroundColor: expertColor, width: `${expertWidth}%`, transition: 'width 0.5s ease-in-out' }}
            />
          </div>
          <p className="w-28 text-right font-bold">
            Expert: <span style={{ color: expertColor }}>{expertScore.toLocaleString('en-US')}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default memo(BeatTheExpertQuestionProgress);
